var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "theme-test" }, [
    _c("h3", [_vm._v("Theme Colors Test")]),
    _vm.userThemeColors
      ? _c("div", { staticClass: "theme-info" }, [
          _vm._m(0),
          _c(
            "ul",
            _vm._l(_vm.userThemeColors, function(color, key) {
              return _c("li", { key: key }, [
                _c("span", {
                  style: {
                    backgroundColor: color,
                    width: "20px",
                    height: "20px",
                    display: "inline-block",
                    marginRight: "10px"
                  }
                }),
                _vm._v(
                  "\n        " + _vm._s(key) + ": " + _vm._s(color) + "\n      "
                )
              ])
            }),
            0
          )
        ])
      : _c("div", { staticClass: "no-theme" }, [
          _c("p", [_vm._v("No theme colors found in userData.themeColors")])
        ]),
    _c("div", { staticClass: "theme-preview" }, [
      _c("h4", [_vm._v("Theme Preview:")]),
      _c(
        "div",
        {
          staticClass: "preview-sidebar",
          style: {
            backgroundColor: _vm.getThemeColor(
              "sidebar_background_color",
              "#96b363"
            )
          }
        },
        [
          _c(
            "p",
            {
              style: { color: _vm.getThemeColor("sidebar_text_color", "white") }
            },
            [_vm._v("Sidebar Background")]
          )
        ]
      ),
      _c(
        "div",
        {
          staticClass: "preview-header",
          style: {
            backgroundColor: _vm.getThemeColor(
              "header_background_color",
              "white"
            )
          }
        },
        [
          _c(
            "p",
            {
              style: {
                color: _vm.getThemeColor("header_text_color", "#782b54")
              }
            },
            [_vm._v("Header Background")]
          )
        ]
      ),
      _c(
        "div",
        {
          staticClass: "preview-button",
          style: {
            backgroundColor: _vm.getThemeColor(
              "button_background_color",
              "white"
            ),
            color: _vm.getThemeColor("button_text_color", "black"),
            border:
              "1px solid " +
              _vm.getThemeColor("button_border_color", "#BDA340"),
            padding: "10px",
            borderRadius: "5px",
            display: "inline-block"
          }
        },
        [_vm._v("\n      Button Preview\n    ")]
      )
    ])
  ])
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("p", [_c("strong", [_vm._v("Current Theme Colors:")])])
  }
]
render._withStripped = true

export { render, staticRenderFns }